@let product = item();
@if (product) {
  <div class="general-info" [formGroup]="form()">
    @for (field of filteredFields(); track field.key) {
      @if (field.key !== 'productType' || isEditable()) {
        <div class="general-info__field" [ngClass]="field.class">
          <div class="general-info__label">{{ field.label | translate }}</div>
          @if (isEditable()) {
            @switch (field.key) {
              @case ('productType') {
                <div class="general-info__input custom-native-select">
                  <mat-select formControlName="productType">
                    <mat-option value="single">
                      {{ 'inventory.productType.single' | translate }}
                    </mat-option>

                    <mat-option value="variants">
                      {{ 'inventory.productType.variants' | translate }}
                    </mat-option>
                  </mat-select>
                </div>
              }
              @case ('productDescription') {
                <textarea
                  class="general-info__input general-info__textarea"
                  [class.has-error]="
                    form().get(field.key)?.invalid && form().get(field.key)?.touched
                  "
                  [formControlName]="field.key"
                  [placeholder]="field.placeholder | translate"
                  [rows]="productDescriptionRows()"
                  appAutoSize
                ></textarea>
              }

              @case ('productCategory') {
                <div
                  class="general-info__input custom-native-select"
                  [class.has-error]="
                    form().get(field.key)?.invalid && form().get(field.key)?.touched"
                >
                  <mat-select
                    [formControlName]="field.key"
                    [placeholder]="field.placeholder | translate"
                  >
                    @for (category of categories(); track category.id) {
                      <mat-option [value]="category.id">
                        {{ category.name }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              }
              @default {
                <input
                  type="text"
                  class="general-info__input"
                  [class.has-error]="
                    form().get(field.key)?.invalid && form().get(field.key)?.touched"
                  [placeholder]="field.placeholder | translate"
                  [formControlName]="field.key"
                />
              }
            }
            @if (form().get(field.key)?.invalid && form().get(field.key)?.touched) {
              <div class="general-info__error">
                @if (form().get(field.key)?.hasError('required')) {
                  <span class>{{ getRequiredMessage(field.key) | translate }}</span>
                }
                @if (form().get(field.key)?.hasError('pattern') && getInvalidMessage(field.key)) {
                  <span>{{ getInvalidMessage(field.key) | translate }}</span>
                }
              </div>
            }
          } @else if (field.key !== 'productType') {
            @let val = field.value(product);
            <div class="general-info__value">
              @if (field.pipe) {
                {{ val | number: field.pipe.args }}
              } @else {
                {{ val }}
              }
            </div>
          }
        </div>
        @if (field.key === 'productDescription' && isEditable()) {
          <div class="general-info__toggle-container">
            <mat-slide-toggle formControlName="isActive">
              <span class="general-info__toggle-label">{{ 'Active' | translate }}</span>
            </mat-slide-toggle>
          </div>
        }
      }
    }
  </div>
}
